import { IconButton } from "@circleco/compass/components/IconButton";
import { Popover as CompassPopover } from "@circleco/compass/components/Popover";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { GiphyPicker } from "../GiphyPicker";

export const GifPopover = () => {
  const [isOpen, setIsOpen] = useState(false);

  const trigger = (
    <Tooltip content={t("tiptap.add_gif")} side="bottom">
      <IconButton
        icon="gif-square"
        size="md"
        variant="ghost"
        aria-label={t("tiptap.add_gif")}
        data-testid="add_gif_message"
      />
    </Tooltip>
  );

  return (
    <CompassPopover
      trigger={trigger}
      open={isOpen}
      onOpenChange={setIsOpen}
      side="top"
      align="start"
      sideOffset={10}
    >
      <GiphyPicker close={() => setIsOpen(false)} />
    </CompassPopover>
  );
};
